import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/reminders")({
  component: lazyRouteComponent(
    () => import("@/features/reminders/components/reminders-page"),
    "RemindersPage",
  ),
});
